import { paymentTypeFromTypename } from '#src/app/shared/utils/payments';

import type { PromoteFormViewerFieldsFragment } from '../../shared/api/promoteFormViewerFields.graphql';
import type { SavedPaymentMethod } from '../context';

type PaymentMethods = NonNullable<
	NonNullable<PromoteFormViewerFieldsFragment['user']>['authOnlyData']
>['paymentMethods'];

export function normalizeSavedPaymentMethods(paymentMethods: PaymentMethods | undefined): SavedPaymentMethod[] {
	if (!paymentMethods) return [];
	return (
		paymentMethods
			// Remove any saved payment methods that can't be used
			.filter(
				(paymentMethod) => paymentMethod.settings.supportsOneTimeCharges, // This field being set is another condition that makes it valid for use.
			)
			// Add a type field to each one for use throughout the UI logic, for tracking events, etc
			.map((paymentMethod): SavedPaymentMethod => {
				if (paymentMethod.__typename === 'PaymentMethodOther') {
					return { ...paymentMethod, type: undefined };
				}
				return {
					...paymentMethod,
					type: paymentTypeFromTypename(paymentMethod.__typename),
				};
			})
	);
}
